import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countJsonFilter'
})
export class CountJsonFilterPipe implements PipeTransform {

  transform(items: any[], column: any, filterText: string): any {
    const f = items.filter(args => args[column].toLowerCase().includes(filterText.toLowerCase()));
    return f ? f.length : 0;
  }

}
